import React from 'react';
import { handlePhoneMask } from 'utils';

export const onInputName = (
  event:
    | React.KeyboardEvent<HTMLInputElement>
    | React.ChangeEvent<HTMLInputElement>
) => {
  const target = event.target as HTMLInputElement;
  if (target.value.length > 255) target.value = target.value.replace(/.$/g, '');
  else target.value = target.value.replace(/[^a-zà-ÿ`~´^¨ ]|÷+/gi, '');
};

export const onInputPhone = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const target = event.target as HTMLInputElement;

  if (target.value.length > 15) target.value = target.value.replace(/.$/g, '');
  else target.value = handlePhoneMask(target.value);
};
